<template>
    <QResourceMenu :links="links" />
</template>

<script>
import QResourceMenu from './QResourceMenu';

export default {
    name: 'QResourceMenuCss',
    components: {
        QResourceMenu,
    },
    computed: {
        links() {
            const QuilityUURL = this.hasRole(['Exec', 'SuperAdmin', 'Staff'])
                ? 'https://quility.lightspeedvt.com/'
                : 'https://auth.quility.com/samlp/z6P8HtF55HXSgXbAT1anWb2BMM2Fdko0';

            if (this.hasRole('UnlicensedAgent')) {
                return [
                    {
                        href: 'https://calendars.sfglife.com/wp-login.php',
                        title: 'Events',
                        color: 'q_engagement_1',
                        icon: 'icon-events',
                    },
                    {
                        href: QuilityUURL,
                        title: 'Quility U',
                        color: 'q_blue_1',
                        icon: 'icon-quility-u',
                    },
                ];
            }

            let items = [
                {
                    title: 'Opt!',
                    color: 'q_leads_1',
                    icon: 'icon-q-leads',
                    function: 'OptSSO',
                },
                {
                    href: QuilityUURL,
                    title: 'Quility U',
                    color: 'q_blue_1',
                    icon: 'icon-quility-u',
                },
                {
                    href: 'https://sfg.ninjadialer.com/#/login/quilitylogin',
                    title: 'Ninja Dialer ',
                    color: 'q_resources_1',
                    icon: 'icon-q-dialer',
                },
            ];

            //if this agent has switchboard then... insert switchboard after Opt. 
            const SwitchboardConfig = this.getConfig('SwitchboardConfig');
            if (SwitchboardConfig){
                items.splice(1, 0, 
                    {
                        href: 'https://switchboard.quility.com/v2/location/' + SwitchboardConfig.location_id + '/dashboard',
                        title: 'Switchboard',
                        color: 'q_leads_2',
                        icon: 'icon-switchboard',
                    },
                );
            }
            else {
                items.splice(1, 0, 
                    {
                        href: 'https://hq.quility.com/page/switchboard-activate',
                        title: 'Switchboard',
                        color: 'q_leads_2',
                        icon: 'icon-switchboard',
                    },
                );
            }

            if (this.user.Agent.IULCertifiedInd) {
                items.push({
                    href: 'https://iulpathfinder.quility.com',
                    title: 'IUL Pathfinder',
                    // color: '#005851',
                    color: 'q_blue_1',
                    icon: 'icon-pathfinder_q',
                })
            }

            return items;
        },
    },
};
</script>
